import { AlertCircle, Inbox, LoaderCircle, RefreshCw } from "lucide-react";
import { Button } from "./Button";

export function LoadingState({ label = "正在加载…", compact = false }) {
  return (
    <div className={`feedback-state ${compact ? "feedback-state--compact" : ""}`} role="status" aria-live="polite">
      <LoaderCircle className="is-spinning" size={22} />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ title = "暂无数据", description, icon: Icon = Inbox, action }) {
  return (
    <div className="feedback-state">
      <Icon size={28} />
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
      {action}
    </div>
  );
}

export function ErrorState({ title = "加载失败", message, onRetry, compact = false }) {
  return (
    <div className={`feedback-state feedback-state--error ${compact ? "feedback-state--compact" : ""}`} role="alert">
      <AlertCircle size={22} />
      <strong>{title}</strong>
      {message ? <p>{message}</p> : null}
      {onRetry ? <Button size="sm" icon={RefreshCw} onClick={onRetry}>重试</Button> : null}
    </div>
  );
}

export function Skeleton({ rows = 4 }) {
  return (
    <div className="skeleton-stack" aria-label="正在加载" role="status">
      {Array.from({ length: rows }, (_, index) => <span key={index} style={{ width: `${90 - (index % 3) * 12}%` }} />)}
    </div>
  );
}
